import { api } from './client';

export type LocationType = 'PARKING' | 'ENTRANCE';

export interface OfficeInfo {
  id: string;
  name: string;
}

export interface ClientLocation {
  id: string;
  clientId: number;
  type: LocationType;
  name: string;
  latitude: number;
  longitude: number;
  note: string | null;
  officeId: string | null;
  office: OfficeInfo | null; // null = основной офис
  createdAt: string;
  updatedAt: string;
}

export interface ClientOffice {
  id: string | null; // null = основной офис
  name: string;
  isMain: boolean;
}

export interface CreateLocationDto {
  type: LocationType;
  name: string;
  latitude: number;
  longitude: number;
  note?: string;
  officeId?: string | null;
}

export interface UpdateLocationDto {
  type?: LocationType;
  name?: string;
  latitude?: number;
  longitude?: number;
  note?: string;
  officeId?: string | null;
}

/**
 * Get all locations for a client
 */
export async function getClientLocations(clientId: number): Promise<ClientLocation[]> {
  const response = await api.get<ClientLocation[]>(`/clients/${clientId}/locations`);
  return response.data;
}

/**
 * Get list of offices for a client (main + additional)
 */
export async function getClientOffices(clientId: number): Promise<ClientOffice[]> {
  const response = await api.get<ClientOffice[]>(`/clients/${clientId}/locations/offices`);
  return response.data;
}

/**
 * Get a single location by ID
 */
export async function getClientLocation(clientId: number, id: string): Promise<ClientLocation> {
  const response = await api.get<ClientLocation>(`/clients/${clientId}/locations/${id}`);
  return response.data;
}

/**
 * Create a new location for a client
 */
export async function createClientLocation(
  clientId: number,
  data: CreateLocationDto
): Promise<ClientLocation> {
  const response = await api.post<ClientLocation>(`/clients/${clientId}/locations`, data);
  return response.data;
}

/**
 * Update an existing location
 */
export async function updateClientLocation(
  clientId: number,
  id: string,
  data: UpdateLocationDto
): Promise<ClientLocation> {
  const response = await api.patch<ClientLocation>(`/clients/${clientId}/locations/${id}`, data);
  return response.data;
}

/**
 * Delete a location
 */
export async function deleteClientLocation(clientId: number, id: string): Promise<void> {
  await api.delete(`/clients/${clientId}/locations/${id}`);
}

// Location type labels and colors
export const LOCATION_TYPE_LABELS: Record<LocationType, string> = {
  PARKING: 'Парковка',
  ENTRANCE: 'Вход',
};

export const LOCATION_TYPE_COLORS: Record<LocationType, string> = {
  PARKING: '#3b82f6', // blue
  ENTRANCE: '#22c55e', // green
};
